<template>
  <form class="reset-password auth__form" @submit.prevent="">
    <template v-if="!isSended">
      <header>
        <h3 class="reset-password__title">Восстановить доступ</h3>
        <p class="reset-password__subtitle reset-password__subtitle_email">
          Введи email, к которому привязан аккаунт, чтобы получить ссылку для смены пароля
        </p>
      </header>
      <main>
        <Input
          v-model="$v.email.$model"
          class="reset-password__input"
          :error="!editingEmail && ($v.email.$error || isEmailNotExist)"
          type="email"
          label="Email"
          :error-message="emailError"
          placeholder="Введи email"
          @input="
            () => {
              isEmailNotExist = false;
            }
          "
          @focus="editingEmail = true"
          @blur="editingEmail = false"
        />
        <Button
          class="reset-password__button double-col"
          :disabled="!isValidForm"
          :loading="isLoading"
          @click="submit()"
        >
          Отправить ссылку
        </Button>
      </main>
    </template>
    <template v-else>
      <header>
        <h3>Письмо отправлено</h3>
      </header>
      <main class="reset-password__sended-main">
        <div class="reset-password__icon">
          <SendedMessageIcon />
        </div>
        <p class="reset-password__subtitle reset-password__subtitle_letter">
          Письмо для восстановления пароля<br />направлено на email
          <span>{{ email }}</span>
        </p>
      </main>
    </template>
    <footer>Вспомнил пароль? <router-link to="/login"> Войти </router-link></footer>
  </form>
</template>
<script>
import Input from '@/components/UiKit/v2/Input';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import Button from '@/components/UiKit/v2/Button';
import SendedMessageIcon from '@/components/Icons/SendedMessage.vue';
import { mapState } from 'vuex';

export default {
  name: 'ResetPassword',
  components: {
    Input,
    Button,
    SendedMessageIcon
  },
  data: () => ({
    email: '',
    isSended: false,
    isEmailNotExist: false,
    editingEmail: false
  }),
  computed: {
    ...mapState('security', {
      isLoading: state => state.meta.registering
    }),
    emailError() {
      return !this.$v.email.email
        ? 'Некорректный e-mail'
        : !this.$v.email.maxLength
        ? 'Слишком длинный e-mail'
        : this.isEmailNotExist
        ? 'Такого Email не существует'
        : '';
    },
    isValidForm() {
      return !this.$v.email.$invalid;
    }
  },
  methods: {
    async submit() {
      const res = await this.$store.dispatch('security/sendResetEmail', this.email);
      if (res === 'success') {
        this.isSended = true;
      }
      if (res == 'error') {
        this.isEmailNotExist = true;
      }
    }
  },
  validations: {
    email: {
      required,
      maxLength: maxLength(256),
      email
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';
.reset-password {
  width: 422px;

  @media all and (max-width: 1280px) {
    width: 100%;
  }

  &__title {
    margin-bottom: 10px;
    text-align: center;
  }

  &__subtitle {
    @extend %text-500-14;
    text-align: center;
    letter-spacing: -0.3px;
    color: #76767b;
    margin: 0 auto;

    &_letter {
      max-width: 40ch;

      span {
        color: $ui-black;
      }
    }

    &_email {
      max-width: 46ch;

      @media all and (max-width: 1280px) {
        max-width: 40ch;
      }
    }
  }

  &__input {
    margin-bottom: 30px;
  }

  main {
    margin-bottom: 60px;
    @media all and (max-width: 1280px) {
      margin-bottom: 130px;
    }

    &.reset-password__sended-main {
      @media all and (max-width: 1280px) {
        margin-bottom: 104px;
      }
    }
  }

  &__icon {
    width: 100px;
    height: 87px;
    margin: 0 auto 40px;
    @media all and (max-width: 1280px) {
      margin: 0 auto 50px;
    }
  }
}
</style>
